// 16x16 "X" with a 2.5px stroke, drawn in currentColor so the caller sets its colour.
const CloseCrossSvg = ({
  height = 16,
  width = 16,
  viewBox = '0 0 16 16',
  strokeWidth = 2.5,
}: {
  height?: number | string;
  width?: number | string;
  viewBox?: string;
  strokeWidth?: number | string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M1.25 1.25L14.75 14.75M14.75 1.25L1.25 14.75"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CloseCrossSvg;
